export default {
  meta: {
    title: '会话记录'
  }
};
